import styled from "styled-components";

export const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(10, 10, 10, 0.85);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
`;

export const TooltipBox = styled.div`
  background: ${({ theme }) => theme.THEME.black};
  padding: 32px;
  border-radius: 16px;
  max-width: 320px;
  color: ${({ theme }) => theme.THEME.white};
  font-family: "Inter", sans-serif;
  font-size: ${({ theme }) => theme.CONSTANTS.XR * 24}px;
  line-height: 1.5;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  p {
    margin-bottom: 24px;

    strong {
      color: ${({ theme }) => theme.THEME.neonBlue};
    }

    em {
      font-style: italic;
      color: ${({ theme }) => theme.THEME.grayText};
    }
  }

  @media (min-width: 1025px) {
    font-size: ${({ theme }) => theme.CONSTANTS.XR * 6}px;
  }
`;
